import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import ThemeConsumer from "../ThemeConsumer"
import Typograph from "components/Typograph"

const ModernButton = ({
  id,
  size,
  shape = "full",
  buttonColor,
  withBorderRadius = false,
  sizeRadius,
  textColor,
  onClick,
  classNames,
  text,
  theme,
  type = "button",
  textSize,
  isDisabled = false,
  renderIcon
}) => {
  const hasIcon = !!renderIcon
  const buttonClasses = classnames(
    {
      [theme[`full_${buttonColor}`]]: shape === "full",
      [theme[`outline_${buttonColor}`]]: shape === "outline",
      [theme.radius]: withBorderRadius,
      [theme.disabled]: isDisabled,
      [theme[`disabled_${shape}`]]: isDisabled,
      [theme[`radius_${sizeRadius}`]]: withBorderRadius && sizeRadius,
      "u-flex u-flexAlignItemsCenter": hasIcon
    },
    theme[`size_${size}`],
    theme.outline,
    classNames
  )

  return (
    <button
      type={type}
      id={id}
      className={buttonClasses}
      onClick={onClick}
      disabled={isDisabled}
    >
      {hasIcon && <div className={theme.containerIcon}>{renderIcon()}</div>}
      <Typograph
        htmlTag="span"
        weight="bold"
        size={textSize || size}
        color={!isDisabled ? textColor : "silver_chalice"}
      >
        {text}
      </Typograph>
    </button>
  )
}

ModernButton.propTypes = {
  id: PropTypes.string,
  size: PropTypes.string,
  shape: PropTypes.oneOf(["full", "outline"]),
  buttonColor: PropTypes.string,
  withBorderRadius: PropTypes.bool,
  textColor: PropTypes.string,
  onClick: PropTypes.func,
  classNames: PropTypes.string,
  text: PropTypes.string,
  theme: PropTypes.object,
  type: PropTypes.string,
  textSize: PropTypes.string,
  isDisabled: PropTypes.bool,
  sizeRadius: PropTypes.string,
  renderIcon: PropTypes.func
}

export default ThemeConsumer("UIModernButton")(ModernButton)



// WEBPACK FOOTER //
// ./src/shared/components/Button/ModernButton.js